/*
  src/redux/kpis/reducer.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from '../update';
import { asObject } from '../../../shared/utils';


import {
  // KPIS_REQUESTED,
  DASHBOARD_KPIS_LOADED,
  AGENCY_KPIS_LOADED,
  BRAND_KPIS_LOADED,
  CAMPAIGN_KPIS_LOADED,
  ALL_CAMPAIGN_KPIS_LOADED
  // KPIS_FAILED_TO_LOAD
} from './constants';

const initialState = {
  brands:{},
  campaigns:{},
  engagements:{},
};

export default function(state=initialState,action){
  switch(action.type){
  case DASHBOARD_KPIS_LOADED:
    return update(state,{
      campaigns:{
        $deepMerge:asObject(action.payload.campaignKPIs || [],'campaignId')
      },
      brands:{
        $deepMerge:asObject(action.payload.brandKPIs || [],'brandId')
      }
    });

  case AGENCY_KPIS_LOADED:
    return update(state,{
      agencies:{
        $deepMerge:asObject(action.payload,'agencyId')
      }
    });

  case BRAND_KPIS_LOADED:
    return update(state,{
       brands:{
        $deepMerge:asObject(action.payload,'brandId')
      }
    });

  case CAMPAIGN_KPIS_LOADED:
    return update(state,{
      campaigns:{
        $deepMerge:{
          [action.payload.campaignId]:action.payload
        }
      },
      //WE PROBABLY DONT NEED THIS ANYMORE
      engagements: {
        $deepMerge: {
          [action.payload.campaignId]: action.payload
        }
      }
    });

  case ALL_CAMPAIGN_KPIS_LOADED:
    return update(state,{
      campaigns:{
        $deepMerge:asObject(action.payload,'id')
      }
    });

  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/kpis/reducer.js